import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  isActive?: boolean;
}

const WarningIcon: React.FC<IconProps> = ({
  width = 27.02,
  height = 23.94,
  isActive = false,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 28 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.732 1.19739L27.244 21.1361C27.4195 21.4401 27.5119 21.785 27.5119 22.136C27.5119 22.4871 27.4195 22.832 27.244 23.136C27.0685 23.4401 26.816 23.6925 26.512 23.8681C26.2079 24.0436 25.8631 24.136 25.512 24.1361H2.48799C2.13692 24.136 1.79204 24.0436 1.488 23.8681C1.18397 23.6925 0.931504 23.4401 0.755974 23.136C0.580443 22.832 0.488035 22.4871 0.488037 22.136C0.488039 21.785 0.580452 21.4401 0.755986 21.1361L12.268 1.19739C13.0373 -0.135946 14.9613 -0.135946 15.732 1.19739ZM14 17.0001C13.6464 17.0001 13.3072 17.1405 13.0572 17.3906C12.8071 17.6406 12.6667 17.9798 12.6667 18.3334C12.6667 18.687 12.8071 19.0261 13.0572 19.2762C13.3072 19.5262 13.6464 19.6667 14 19.6667C14.3536 19.6667 14.6927 19.5262 14.9428 19.2762C15.1928 19.0261 15.3333 18.687 15.3333 18.3334C15.3333 17.9798 15.1928 17.6406 14.9428 17.3906C14.6927 17.1405 14.3536 17.0001 14 17.0001ZM14 7.66672C13.6734 7.66676 13.3582 7.78666 13.1142 8.00367C12.8701 8.22069 12.7142 8.51972 12.676 8.84405L12.6667 9.00005V14.3334C12.667 14.6732 12.7972 15.0001 13.0305 15.2472C13.2637 15.4943 13.5826 15.643 13.9218 15.663C14.2611 15.6829 14.5952 15.5725 14.8558 15.3544C15.1164 15.1362 15.2838 14.8268 15.324 14.4894L15.3333 14.3334V9.00005C15.3333 8.64643 15.1928 8.30729 14.9428 8.05725C14.6927 7.8072 14.3536 7.66672 14 7.66672Z"
      fill="#FF5249"
    />
  </svg>
);

export default WarningIcon;
